import { __assign } from "tslib";
import { ItemType } from '../domain';
export * from './custom-field-type.enum';
export * from './testkit';
export * from './dto';
export * from './custom-fields-configuration-data';
export * from './multilevel-custom-field.builder';
export * from './multilevel-custom-field-value.builder';
export var createSimpleCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = baseUrl + "/fields";
    return {
        getCustomFields: function () { return http.get("" + url); },
        getCustomField: function (id) { return http.get(url + "/" + id); },
        adminGetCustomField: function (id) { return http.get(url + "/" + id + "/admin"); },
        adminGetCustomFields: function () { return http.get(url + "/admin"); },
        addCustomField: function (dto) { return http.post("" + url, __assign(__assign({}, dto), { itemType: itemType })); },
        updateCustomField: function (dto) { return http.put(url + "/" + dto.id, dto); },
        deleteCustomField: function (id) { return http.delete(url + "/" + id); },
    };
};
export var createMultiLingualCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = baseUrl + "/fields";
    return {
        getCustomFields: function () { return http.get("" + url); },
        getCustomField: function (id) { return http.get(url + "/" + id); },
        adminGetCustomField: function (id) { return http.get(url + "/" + id + "/admin"); },
        adminGetCustomFields: function () { return http.get(url + "/admin"); },
        addCustomField: function (dto) { return http.post("" + url, __assign(__assign({}, dto), { itemType: itemType })); },
        updateCustomField: function (dto) { return http.put(url + "/" + dto.id, dto); },
        deleteCustomField: function (id) { return http.delete(url + "/" + id); },
    };
};
export var createMultilevelCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = baseUrl + "/fields/multiLevel";
    return {
        addMultilevelCustomField: function (dto) { return http.post("" + url, __assign(__assign({}, dto), { itemType: itemType })); },
        updateMultilevelCustomField: function (dto) { return http.put(url + "/" + dto.id, dto); },
    };
};
export var createCustomFieldsApi = function (baseUrl, http) {
    var ticketsUrl = baseUrl + "/tickets";
    var usersUrl = baseUrl + "/users";
    var companiesUrl = baseUrl + "/companies";
    return {
        users: createSimpleCustomFieldsApi(usersUrl, http, ItemType.USER),
        companies: createSimpleCustomFieldsApi(companiesUrl, http, ItemType.COMPANY),
        tickets: createMultiLingualCustomFieldsApi(ticketsUrl, http, ItemType.TICKET),
        multilevel: createMultilevelCustomFieldsApi(ticketsUrl, http, ItemType.TICKET),
    };
};
//# sourceMappingURL=index.js.map